import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type CancelAppointmentMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  updatedby?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CancelAppointmentMutation = { __typename?: 'mutation_root', update_appointments?: { __typename?: 'appointments_mutation_response', affected_rows: number } | null };


export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($id: bigint!, $updatedby: String) {
  update_appointments(
    where: {id: {_eq: $id}}
    _set: {status: "canceled", updatedby: $updatedby, updatedat: "now()"}
  ) {
    affected_rows
  }
}
    `;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedby: // value for 'updatedby'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appointments/queries/cancelAppointment.mutation.gql}
 */
export async function cancelAppointment(
  variables: CancelAppointmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CancelAppointmentMutation['update_appointments']>
export async function cancelAppointment(
  variables: CancelAppointmentMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CancelAppointmentMutation>
export async function cancelAppointment(
  variables: CancelAppointmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CancelAppointmentMutation['update_appointments'] | CancelAppointmentMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CancelAppointmentMutation>(
    CancelAppointmentDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_appointments
}